import HelpMenuContents from "@/components/Dashboard/HelpMenu/HelpMenuContents";
import HelpMenuContent from "@/components/Dashboard/HelpMenu/HelpMenuContent";
import HelpMenuContentDetails from "@/components/Dashboard/HelpMenu/HelpMenuContentDetails";

const helpMenuContentRoutes = [
    {
        path: "helpMenuContents",
        component: HelpMenuContents,
        roles: ["PanelUser"],
        meta: {
            required: true,
        },
        name: "HelpMenuContents",
    },
    {
        path: "helpMenuContent",
        component: HelpMenuContent,
        roles: ["PanelUser"],
        meta: {
            required: true,
        },
        name: "HelpMenuContent",
    },
    {
        path: "helpMenuContent/:id",
        component: HelpMenuContentDetails,
        roles: ["PanelUser"],
        meta: {
            required: true,
        },
        name: "HelpMenuContentDetails",
    },
]

export default helpMenuContentRoutes;